import { useQuery } from "@tanstack/react-query";
import { format } from "date-fns";
import { useSelector } from "react-redux";
import ApiService from "../../services/ApiService";

/**
 * Engagement Value per channel over time: Earned, Tracked.
 * Same sources as the Engagement Value donut, so the bars add up to it.
 */
const usePAEngagementValueTimeline = (rightsholderId = 0, parentTenantId = null) => {
  const tenant = useSelector((state) => state.auth.tenant);
  const date = useSelector((state) => state.date);
  const { startDate, endDate } = date;
  const enabled = !!(startDate && endDate);

  let since, until;
  if (enabled) {
    since = format(new Date(startDate), "yyyy-MM-dd");
    until = format(new Date(endDate), "yyyy-MM-dd");
  }

  return useQuery({
    queryKey: ["PA_VALUE_TIMELINE", "engagement", tenant.id, rightsholderId, parentTenantId, startDate, endDate],
    queryFn: () => ApiService.getPlacementAnalysisValueTimeline({
      view: "engagement",
      rightsholderId,
      parentTenantId,
      since,
      until,
    }),
    select: (data) => data.data.graphs,
    enabled,
    placeholderData: { data: { graphs: [] } },
  });
};

export default usePAEngagementValueTimeline;
